"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var SvgNoTasks = function SvgNoTasks(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M59.16 28.74L48.151 12.226A5 5 0 0043.991 10H16.009a5 5 0 00-4.16 2.226L.84 28.74A5 5 0 000 31.514V45a5 5 0 005 5h50a5 5 0 005-5V31.514a5 5 0 00-.84-2.774zM16.901 16.667H43.1L51.988 30H39.167l-3.334 6.667H24.167L20.833 30H8.013L16.9 16.667z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M59.16 28.74L48.151 12.226A5 5 0 0043.991 10H16.009a5 5 0 00-4.16 2.226L.84 28.74A5 5 0 000 31.514V45a5 5 0 005 5h50a5 5 0 005-5V31.514a5 5 0 00-.84-2.774zM16.901 16.667H43.1L51.988 30H39.167l-3.334 6.667H24.167L20.833 30H8.013L16.9 16.667z",
    fill: "#FFF",
    opacity: 0.88
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M59.044 27.018L48.164 12.06A5 5 0 0044.121 10H15.879a5 5 0 00-4.043 2.06L.956 27.017A5 5 0 000 29.96V45a5 5 0 005 5h50a5 5 0 005-5V29.96a5 5 0 00-.956-2.942zM14.532 14.02c.314-.43.814-.686 1.347-.687h28.242c.531 0 1.035.257 1.348.687l9.197 12.647H40.44l-3.333 6.666H22.893l-3.333-6.666H5.334l9.198-12.647zm42.135 17.647V45c0 .92-.748 1.667-1.667 1.667H5A1.669 1.669 0 013.333 45V31.667C3.333 30.747 4.08 30 5 30h12.5l3.333 6.667h18.334L42.5 30H55c.92 0 1.667.746 1.667 1.667z",
    fill: "currentColor"
  })));
};
var _default = exports.default = SvgNoTasks;